import { AffiliateCode } from "@/constants/affiliateCode"

export function getProductVariant(affiliateCode: string | null) {
    switch (affiliateCode) {
        case AffiliateCode.OCTOPUS_DIRECT:
            return "cocon"
        case AffiliateCode.OCTOPUS_DIRECT_LOW_COMPLEXITY:
            return "low-complexity"
        case AffiliateCode.OCTOPUS_DIRECT_LOW_PRICE:
            return "low-price"
        default:
            return undefined
    }
}
